module.exports = {
    CONFIRMED: 'CONFIRMED',
    FORCE_CHANGE_PASSWORD: 'FORCE_CHANGE_PASSWORD',
    UNCONFIRMED: 'UNCONFIRMED'
}